import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Button, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./styles";

/**
 * Reusable payment receipt shown after a card-on-file charge. Mirrors the "Approved"
 * receipt used by the Edit Balance / on-file payment flow: it displays the transaction
 * number, total paid, last 4 of card, card type, and authorization code, with a single
 * Close action. A declined payment (`isPaymentSuccessful === false`) shows the declined
 * header without the details grid.
 */
const PaymentApprovedReceipt = ({ transactionDetails, onClose, className }) => {
  const classes = useStyles();

  if (!transactionDetails) return null;

  const isDeclined = transactionDetails.isPaymentSuccessful === false;

  return (
    <div className={clsx("transaction-container", classes.transactionContainer, className)}>
      <div className={clsx("transaction-header", classes.transactionHeader)}>
        <Typography variant="h5" color="primary">
            Approved
        </Typography>
      
      </div>

      {!isDeclined && (
        <Grid container spacing={2} className={clsx("transaction-details", classes.transactionDetails)}>
          <Grid item xs={6}><Typography align="left"><strong>Transaction Number:</strong></Typography></Grid>
          <Grid item xs={6}><Typography align="left">{transactionDetails.transactionNumber}</Typography></Grid>

          <Grid item xs={6}><Typography align="left"><strong>Total Paid:</strong></Typography></Grid>
          <Grid item xs={6}><Typography align="left">${transactionDetails.totalPaid}</Typography></Grid>

          <Grid item xs={6}><Typography align="left"><strong>Last 4 of Card:</strong></Typography></Grid>
          <Grid item xs={6}><Typography align="left">{transactionDetails.last4}</Typography></Grid>

          <Grid item xs={6}><Typography align="left"><strong>Card Type:</strong></Typography></Grid>
          <Grid item xs={6}><Typography align="left">{transactionDetails.cardType}</Typography></Grid>

          <Grid item xs={6}><Typography align="left"><strong>Authorization Code:</strong></Typography></Grid>
          <Grid item xs={6}><Typography align="left">{transactionDetails.authorizationCode}</Typography></Grid>
        </Grid>
      )}

      <div className={clsx("transaction-actions", classes.transactionActions)}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          className={clsx("transaction-button", classes.transactionButton)}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

PaymentApprovedReceipt.propTypes = {
  transactionDetails: PropTypes.shape({
    isPaymentSuccessful: PropTypes.bool,
    transactionNumber: PropTypes.string,
    totalPaid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    last4: PropTypes.string,
    cardType: PropTypes.string,
    authorizationCode: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default PaymentApprovedReceipt;
